import React from 'react';
import { EmailOutlined, PhoneOutlined, Facebook, teamImage1, teamImage2, teamImage3, Twitter, Instagram, serviceImage1, serviceImage2, serviceImage3, serviceImage4, logoImage, teamImage7, teamImage6, teamImage5, teamImage4, teamImage8 } from './Images';
import itlogo from "../images/CO-LOGO.png"
// Banner Section Data - Represents the primary message shown in the banner section
export const bannerData = [
  "Building Your Business",
  "Future with Custom Software Development Solutions",
  "At JustSolve, we leverage the latest proven technologies and tools to create intuitive and user-friendly software that can streamline your processes and drive business growth. Our team prioritises speed without compromising quality, to deliver future-proof, enterprise-grade solutions."
];

// Navigation Bar Data - Defines the navigation menu items for the website
export const navigationData = ["Home", "About", "Service", "Team", "Contact"];

// About Section Data - Provides company background and core values
export const aboutData = {
  title: "About Us",
  subtitle: "Your Partner in Digital Innovation.",
  content: [
    "A report by Gartner found that custom software development can help businesses increase productivity and streamline processes, resulting in a 25% increase in efficiency.",
    "This means that investing in custom software development services can increase efficiency, optimise operations, reduce costs, and improve overall performance.",
    "Our focus on custom software development is driven by our belief that every business is unique and deserves an innovative software solution that addresses their specific needs and pain points."
  ]
};

//about services data
export const serviceData = [
  {
    "title": "Cloud Solutions",
    "description": "Our cloud solutions enable businesses to scale effortlessly, ensuring high availability, security, and performance with services like AWS, Azure, and Google Cloud.",
    "image": serviceImage1
  },
  {
    "title": "Cybersecurity Services",
    "description": "We provide top-notch security solutions to protect your digital assets, including threat detection, vulnerability assessments, and data protection strategies.",
    "image": serviceImage2
  },
  {
    "title": "Web Development",
    "description": "From responsive web applications to powerful mobile solutions, we deliver customized development services to meet your business needs.",
    "image": serviceImage3
  },
  {
    "title": "Mobile Development",
    "description": "We craft high-performance mobile applications tailored to your business needs. Whether it's iOS, Android, or cross-platform solutions, we ensure seamless user experiences, robust functionality, and cutting-edge technologies.",
    "image": serviceImage4
  }
]

//contact information
export const contactDetails = [
  {
    icon: <EmailOutlined sx={{ mr: 3 }} />,
    text: "emailhere@gmail.com",
    link: "mailto:emailhere@gmail.com"
  },
  {
    icon: <PhoneOutlined sx={{ mr: 3 }} />,
    text: "+27 123-4567-90",
    link: "tel:+27123456790"
  }
];
// Social Media Links Data - Provides links to popular social media platforms
export const mediaData = [
  { Icon: Facebook, link: "https://www.facebook.com" },
  { Icon: Twitter, link: "https://www.twitter.com" },
  { Icon: Instagram, link: "https://www.instagram.com" }
];

export const companyInfo = {
  name: "Your Company Name",
  logo: itlogo,
  description:
    "We provide end-to-end IT services including software development, cloud solutions, cybersecurity, and digital transformation to help businesses scale with technology-driven innovation.",
  address: "198 West 21th Street",
  phone: "+123 456 78900",
  email: "example@gmail.com",
};
//footer data

export const footerData = `Privacy Policy | Terms & Conditions | © ${new Date().getFullYear()} Company Name. All rights reserved.
`

//contact form Data

export const contactFormData = ["Title *", "First Name *", "Last Name *", "Mobile Number *", "Alternative Mobile Number", "Email *", "Company Name *"];
//Pricing Plans
export const pricingheadingText = "Our Pricing Plans";
export const pricingSubHeadingText = "Select the plan that best fits your requirements";
export const pricingPlans = [
  {
    title: "Bundle Plan",
    price: "$350",
    per: "per Year",
    features: [
      "One Year Hosting",
      "Each Module- Risk,Compliance and Governace",
      "Maximum Limit of Custom Tables",
      "Unlimited Profiles",
      "Dynamic Input Forms",
      "Survey Management",
      "Free SMS Integration",
      "Unlimited Task Management",
      "Full access to all features",
      "Monthly updates",
      "24/7 support"
    ]
  },
  {
    title: "Additional User Plan",
    price: "$5",
    per: "user/month",
    // description: "Perfect for small teams or individual users",
    features: [
      "Full access to all features",
      "24/7 customer support",
      "Monthly updates",
      // "Single user license"
    ]
  },
];





export const teamMembers = [
  {
    id: 1,
    name: "Alice Johnson",
    role: "Frontend Developer",
    image: teamImage1,
    phoneNumber: "+972-526980001"
  },
  {
    id: 2,
    name: "Bob Williams",
    role: "Backend Developer",
    image: teamImage2,
    phoneNumber: "+972-526980002"
  },
  {
    id: 3,
    name: "Charlie Brown",
    role: "UI/UX Designer",
    image: teamImage3,
    phoneNumber: "+972-526980003"
  },
  {
    id: 4,
    name: "David Smith",
    role: "Project Manager",
    image: teamImage4,
    phoneNumber: "+972-526980004"
  },
  {
    id: 5,
    name: "Olivia Turner",
    role: "Full Stack Developer",
    image: teamImage5,
    phoneNumber: "+972-526980101"
  },
  {
    id: 6,
    name: "Ethan Collins",
    role: "DevOps Engineer",
    image: teamImage6,
    phoneNumber: "+972-526980102"
  },
  {
    id: 7,
    name: "Sophia Mitchell",
    role: "Graphic Designer",
    image: teamImage7,
    phoneNumber: "+972-526980103"
  },
  {
    id: 8,
    name: "Liam Johnson",
    role: "Product Owner",
    image: teamImage8,
    phoneNumber: "+972-526980104"
  },
];




